import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: '#f6ff7a', color: '#111', padding: 0 }}>
      {/* Large Heading Section */}
      <Box sx={{ px: { xs: 2, md: 12 }, pt: { xs: 8, md: 12 }, pb: { xs: 6, md: 10 } }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2.2rem', md: '3.5rem', lg: '4rem' },
            mb: 0,
            lineHeight: 1.1,
            color: '#111',
          }}
        >
          Want to Start<br />a Project?
            </Typography>
      </Box>

      {/* Footer Main Row */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: 'space-between',
          px: { xs: 2, md: 12 },
          pb: { xs: 4, md: 6 },
        }}
      >
        {/* Company Name */}
        <Typography variant="h5" sx={{ fontWeight: 500, mb: { xs: 2, md: 0 } }}>
          Browntechint.
            </Typography>
        {/* Nav Links */}
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 2, md: 6 },
            flex: 1,
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
            fontSize: '1.1rem',
            fontWeight: 400,
            flexWrap: { xs: 'wrap', md: 'nowrap' },
            maxWidth: { xs: '100%', md: 'auto' },
          }}
        >
          <Link to="/" style={{ color: '#111', textDecoration: 'none' }}>Home</Link>
          <Link to="/about" style={{ color: '#111', textDecoration: 'none' }}>About</Link>
          <Link to="/blogs" style={{ color: '#111', textDecoration: 'none' }}>Blog</Link>
          <Link to="/portfolio" style={{ color: '#111', textDecoration: 'none' }}>Portfolio</Link>
          <Link to="/contact" style={{ color: '#111', textDecoration: 'none' }}>Contact</Link>
        </Box>
      </Box>

      {/* Thin Line */}
      <Box sx={{ borderBottom: '1.5px solid #222', width: '90%', mx: 'auto', mb: 2 }} />

      {/* Copyright and Legal */}
      <Box
        sx={{
          px: { xs: 2, md: 12 },
          pb: { xs: 4, md: 6 },
          textAlign: { xs: 'left', md: 'left' },
          fontSize: '1rem',
          color: '#222',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 400, display: 'inline' }}>
          © <span data-sitemap-ignore="">{currentYear}</span> Browntechint. All rights reserved
            </Typography>
        <span style={{ margin: '0 1rem' }}>|</span>
        <Typography variant="body2" sx={{ fontWeight: 400, display: 'inline' }}>
          Cookie Settings, Anti-Spam, Privacy, User agreement, Legal Notice and Responsible Disclosure
            </Typography>
      </Box>
    </footer>
  );
};

export default Footer; 